var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1892_4083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.09 11.0881L1.27098 1.30857M11.5299 10.8086L15.9699 8.57643C17.0429 8.03701 17.5793 7.76729 17.7226 7.42868C17.8469 7.13483 17.8236 6.79928 17.6597 6.52549C17.4709 6.20999 16.9023 6.0172 15.7649 5.63163L3.45825 1.45946C2.46725 1.1235 1.97175 0.955513 1.64447 1.07195C1.35975 1.17325 1.1361 1.39787 1.03605 1.68304C0.921053 2.01083 1.09121 2.50558 1.43151 3.4951L5.65762 15.7834C6.04818 16.919 6.24346 17.4868 6.55978 17.6742C6.83429 17.8369 7.16994 17.8588 7.46324 17.7331C7.80122 17.5884 8.06858 17.0507 8.60329 15.9754L10.816 11.5257C10.9041 11.3485 10.9481 11.2599 11.0071 11.1831C11.0594 11.1149 11.1202 11.0538 11.1882 11.0012C11.2647 10.9419 11.3531 10.8975 11.5299 10.8086Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1892_4083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(1.02734 25.0264) rotate(-90.1256)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.d60a34949caa0adaa04be65d474eb512.svg";
export { ForwardRef as ReactComponent };